import { getGTMConfig } from '@/data/events/handlers/gtm';
import { useSettings } from '@/data/Settings';
import { triggerGA4Event } from 'presentation/events/services/ga4EcommerceService';
import { GA4AuthEventPayload } from 'presentation/events/types/ga4Types';
import { useCallback } from 'react';

export const useTrackAuthEvent = () => {
	const { settings } = useSettings();

	return useCallback(
		(payload: GA4AuthEventPayload) => {
			const { ga4 } = getGTMConfig(settings);

			if (!ga4) return;

			triggerGA4Event(payload);
		},
		[settings]
	);
};
